import { PlusIcon } from '@phosphor-icons/react';
import { Formik } from 'components/form/formik';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import dayjs from 'dayjs';

import { getDisplayError } from '../../../utils/get-display-error';
import { sleep } from '../../../utils/sleep';
import { formatInputDate } from '../../../utils/date';
import { Button } from 'components/button/Button';
import { InputField } from 'components/input/InputField';
import { captureException } from '@sentry/react';
import { useTranslation } from '../../../contexts/translation-context';
import { createCarrierPortalTruck } from '../models';
import { useCarrierPortalSupplier } from '../CarrierPortalCarrierContext';

const createTruckSchema = Yup.object().shape({
  licensePlate: Yup.string().required('errors.required'),
  insuranceExpiresAt: Yup.string().required('errors.required'),
  examinationExpiresAt: Yup.string().required('errors.required'),
});

export const CarrierPortalCreateTruckPage = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { carrierId } = useCarrierPortalSupplier();

  return (
    <div>
      <h1 className="heading-one mb-4">{i18n('carrierPortal.trucks.newTruck')}</h1>

      <Formik
        initialValues={{
          licensePlate: '',
          insuranceExpiresAt: formatInputDate(dayjs().add(1, 'year').toDate()),
          examinationExpiresAt: formatInputDate(dayjs().add(1, 'year').toDate()),
        }}
        validationSchema={createTruckSchema}
        onSubmit={async (values) => {
          try {
            await createCarrierPortalTruck(carrierId, values);
            await sleep(100);
            navigate('..');
            toast.success(i18n('carrierPortal.trucks.succeeded'));
          } catch (err: any) {
            captureException(err);
            toast.error(i18n('carrierPortal.trucks.createError') + getDisplayError(err));
          }
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <InputField labelText={i18n('carrierPortal.trucks.licensePlate')} type="text" name="licensePlate" />
            <InputField
              labelText={i18n('carrierPortal.trucks.insuranceExpiresAt')}
              type="date"
              name="insuranceExpiresAt"
            />
            <InputField
              labelText={i18n('carrierPortal.trucks.examinationExpiresAt')}
              type="date"
              name="examinationExpiresAt"
            />
            <Button
              type="submit"
              color="primary"
              iconLeft={<PlusIcon className="button-icon" />}
              isDisabled={isSubmitting}
              isLoading={isSubmitting}
            >
              {i18n('carrierPortal.trucks.create')}
            </Button>
          </form>
        )}
      </Formik>
    </div>
  );
};
